import { render, staticRenderFns } from "./TilesConstructor.vue?vue&type=template&id=8e78b1bc"
import script from "./TilesConstructor.vue?vue&type=script&lang=js"
export * from "./TilesConstructor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e78b1bc')) {
      api.createRecord('8e78b1bc', component.options)
    } else {
      api.reload('8e78b1bc', component.options)
    }
    module.hot.accept("./TilesConstructor.vue?vue&type=template&id=8e78b1bc", function () {
      api.rerender('8e78b1bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tiles-constructor/TilesConstructor.vue"
export default component.exports